import filters from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '承保时间',
          key: 'insureTime',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filters.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保单号',
          key: 'policyNo',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '保单状态',
          slot: 'status',
          width: 120,
          align: 'center',
        },
        {
          title: '所属业务员',
          key: 'salesmanName',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '产品名称',
          key: 'productName',
          minWidth: 280,
          align: 'center'
        },
        {
          title: '投/被保人',
          slot: 'holderName',
          width: 180,
          align: 'center',
        },
        {
          title: '保费（元）',
          key: 'fee',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '预估服务费（元）',
          key: 'incomes',
          minWidth: 180,
          align: 'center'
        },
      ];
      if(this.searchParams.type == 2) {
        columns.push({
          title: '不可结原因',
          slot: 'reason',
          minWidth: 280,
          align: 'center'
        })
      }
      columns = columns.concat([
        {
          title: '出单团队',
          key: 'groupName',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '所属机构',
          key: 'organizationName',
          minWidth: 180,
          align: 'center'
        }
      ])
      this.columns = columns;
    }
  }
};
